import React from "react";
import SomethingWentWrong from "./pages/SomethingWentWrong";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can log error to error tracking service like Sentry
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <SomethingWentWrong clienterror={true}/>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
